module.exports = __webpack_public_path__ + "b60333684c4c3fa0e6529b075ca8e85a.png";